import {
    AccordionButton,
    AccordionButtonIconWrapper,
} from 'components/Accordion';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import styled, { css } from 'styled-components';

const AccordionNestedButtonDropdown = css`
    margin-left: auto;
    font-size: 1.1em;
    color: ${({ theme }) => theme.gray_4};
`;

const AccordionNestedButtonIconWrapper = styled(AccordionButtonIconWrapper)`
    font-size: ${({ theme }) => theme.space_8}px;
    margin-right: ${({ theme }) => theme.space_5}px;
    display: flex;
    align-items: center;
`;

const AccordionNestedButton = styled(AccordionButton).attrs(
    ({ type = 'button' }) => ({
        type,
    }),
)`
    font-size: 0.9rem;
    background-color: ${({ theme, isActive, $isOpen }) => 'transparent'};
    color: ${({ theme }) => theme.gray_1};
    &:hover {
        background-color: ${({ theme, isActive, $isOpen }) => 'transparent'};
    }
`;

function FilterAccordionNestedButton({
    isActive,
    isOpen,
    Icon,
    children,
    ...props
}) {
    return (
        <AccordionNestedButton
            isActive={isActive}
            aria-expanded={isOpen}
            {...props}
        >
            {Icon ? (
                <AccordionNestedButtonIconWrapper
                    aria-hidden="true"
                    isActive={isActive}
                >
                    <Icon />
                </AccordionNestedButtonIconWrapper>
            ) : null}
            {children}
            {isOpen ? (
                <IoMdArrowDropup
                    aria-hidden="true"
                    css={AccordionNestedButtonDropdown}
                />
            ) : (
                <IoMdArrowDropdown
                    aria-hidden="true"
                    css={AccordionNestedButtonDropdown}
                />
            )}
        </AccordionNestedButton>
    );
}

export default FilterAccordionNestedButton;
